export default __webpack_public_path__ + "static/media/cart_dnf.76d77beb.svg";